// discount-config.js
// Single source of the backend URL for all discount-popup scripts.
// Load this BEFORE discount-popup.js:
//   {{ 'discount-config.js' | asset_url | script_tag }}
//   {{ 'discount-popup.js' | asset_url | script_tag }}
//
// On a real store the scripts talk to the backend through the **Shopify App
// Proxy**, i.e. a path on the store's OWN domain
// (https://your-store.com/apps/discounts/...). That path never changes when the
// backend moves, it is same-origin with the storefront (so no CORS), and it
// looks like part of the shop — which is the whole point.
//
// PROXY_PREFIX must match the app proxy configured in the Shopify app:
//   Partner dashboard -> your app -> App setup -> App proxy
//     Subpath prefix : apps
//     Subpath        : discounts
//     Proxy URL      : https://<your-backend-host>/proxy
//
// TUNNEL_URL is an OPTIONAL fallback, and is normally blank. There is no cloud
// host any more: the app runs locally, so the only absolute URL that can exist
// is a temporary Cloudflare tunnel, which `npm run tunnel` / theme-sync writes
// in here for you (never edit it by hand). While it is blank there is nothing to
// fall back to and the App Proxy path is the only route — which is the point.
// Local testing (localhost/127.0.0.1/file://) always talks to localhost:3000.

(function () {
  var TUNNEL_URL = 'https://audio-fruit-elvis-msg.trycloudflare.com'; // AUTO-UPDATED — do not edit by hand
  var PROXY_PREFIX = '/apps/discounts';                   // App Proxy subpath — permanent

  var IS_LOCAL = ['localhost', '127.0.0.1', ''].indexOf(window.location.hostname) !== -1;

  window.DISCOUNT_BACKEND_URL = IS_LOCAL ? 'http://localhost:3000' : (PROXY_PREFIX || TUNNEL_URL);
  // Read by discount-popup.js only if a proxy request comes back looking like
  // the proxy isn't configured. null = nothing to fall back to.
  window.DISCOUNT_BACKEND_FALLBACK = (!IS_LOCAL && PROXY_PREFIX && TUNNEL_URL) ? TUNNEL_URL : null;

  console.log('🔗 Discount backend URL:', window.DISCOUNT_BACKEND_URL, '· local:', IS_LOCAL,
    '· fallback:', window.DISCOUNT_BACKEND_FALLBACK || 'none');
})();
